export const Pages = {
  // System
  ROOT: '/',
  AUTH_CALLBACK: '/callback',
  NO_PERMISSIONS: '/wait',
  NOT_AUTHORIZED: '/not-authorized',
  NOT_FOUND: 'not-found',
  CHANGE_PASSWORD: 'profile/change-password',
  NOMINATIONS: 'nominations',
  MONTHLY_NOMINATIONS: 'monthly-nominations',
  RENOMINATIONS: 'renominations',
  CREATED_RENOMINATIONS_PART: 'created',
  PENDING_RENOMINATION_PART: 'pending',
  FORECAST_VOLUMES: 'forecast-volumes',
  CONSUMPTION_FORECASTS: 'consumption-forecasts',
  BALANCE: 'balance',
  RESOURCE: 'resource',
  RESOURCE_SCHEDULE_PART: 'schedule',
  RESOURCE_BATCHES_PART: 'batches',
  RESOURCE_HISTORY_PART: 'history',
  RESOURCE_SELLERS_PART: 'resource-sellers',
  IMBALANCES: 'imbalances',
  RESOURCE_COVERAGE: 'resource-coverage',
  COUNTERPARTIES_DASHBOARD: 'counterparties-dashboard',
  COUNTERPARTIES: 'counterparties',
  EMPLOYEES_PART: 'employees',
  BANK_DETAILS_PART: 'bank-details',
  CONTRACTS: 'contracts',
  CONTRACT_DETAILS: 'contracts/:contractId',
  CONTRACT_PRICE_HISTORY_PART: 'price-history',
  CONTRACT_PLANNED_VOLUME_PART: 'planned-volume',
  CONTRACT_TERMS_PART: 'terms',
  CONTRACT_DOCUMENTS_PART: 'contract-documents',
  CONTRACT_ADDENDA_PART: 'addenda',
  CONTRACT_ADDENDA_CREATE_PART: 'addenda/new',
  CONTRACT_ADDENDUM_DETAILS_PART: 'addenda/:addendumId',
  CONSUMPTION_OBJECTS: 'consumption-objects',
  METERING_POINT_DETAILS: 'consumption-objects/:meteringPointId',
  ALLOCATION_ACTUAL: 'allocation-actual',
  ALLOCATION_ACTUAL_RESULT: 'result',
  ALLOCATION_ACTUAL_IMPORT_DETAIL: ':importId',
  ALLOCATION_ACTUAL_OPERATOR_DETAIL: ':operatorId',
  ALLOCATION_PRELIMINARY: 'allocation-preliminary',
  ALLOCATION_PRELIMINARY_RESULT: 'result',
  ALLOCATION_PRELIMINARY_IMPORT_DETAIL: ':importId',
  ALLOCATION_PRELIMINARY_OPERATOR_DETAIL: ':operatorId',
  CONSUMPTION_BY_COUNTERPARTY: 'consumption-by-counterparty',
  EIC_CODE_HISTORY: 'eic-code-history',
  COUNTERPARTY_DOCUMENTS: 'counterparty-documents',
  FORM_TEN: 'form-ten',
  REPORTS: 'reports',
  REPORTS_LIST: 'reports-list',
  BI_DASHBOARDS: 'bi-dashboards',
  INVOICE_SETTINGS: 'invoice-settings',
  PHYSICO_CHEMICAL_INDICATOR_SETTINGS: 'physico-chemical-indicator-settings',
  SUPPLIER_PORTFOLIO: 'supplier-portfolio',
  SUPPLIER_PORTFOLIO_IMPORT_DETAILS: 'supplier-portfolio/imports/:importId',
  SUPPLIER_PORTFOLIO_HISTORY: 'supplier-portfolio/history',
  SUPPLIER_PORTFOLIO_HISTORY_IMPORTS_PART: 'imports',
  SUPPLIER_PORTFOLIO_HISTORY_COMPARE_PART: 'compare',
  SUPPLIER_PORTFOLIO_HISTORY_IMPORT_DETAILS:
    'supplier-portfolio/history/imports/:importId',
} as const;

export type Pages = (typeof Pages)[keyof typeof Pages];
